import isStringParsableToInt from '../../util/isStringParsableToInt';
import type { SubTakeData } from './types';

export const sortTakes = (takes: SubTakeData[]) => takes
    .toSorted(({ subTake: a }, { subTake: b }) => getTakeStringSortOrder(a, b))

export const sortTakeGroupsByTake = (a : { take: string }, b: { take: string }) => {
    if (isStringParsableToInt(a.take) && isStringParsableToInt(b.take)) {
        const takeDiff = parseInt(a.take) - parseInt(b.take);
        if (takeDiff !== 0) return takeDiff;
    }

    return a.take.localeCompare(b.take);
}

export const sortTakeGroupsByOrdinal = (a: { ordinal: number }, b: { ordinal: number }) => {
    return a.ordinal - b.ordinal;
}

export const sortByTakeAndSubTake = (a: { take: string, subTake: string }, b: { take: string, subTake: string }) => {
    const takeDiff = sortTakeGroupsByTake(a, b);
    if (takeDiff !== 0) return takeDiff;

    // special sort function that takes into acount string length for sorting a, b, aa...
    return getTakeStringSortOrder(a.subTake, b.subTake);
}

export const sortByCombinedTakeAndSubTake = (a: { take: string }, b: { take: string }) => {
    const aTake = a.take.replace(/[^0-9]/g, '');
    const bTake = b.take.replace(/[^0-9]/g, '');
    const aSubTake = a.take.replace(/[0-9]/g, '');
    const bSubTake = b.take.replace(/[0-9]/g, '');
    return sortByTakeAndSubTake({ take: aTake, subTake: aSubTake }, { take: bTake, subTake: bSubTake });
}

export const sortBySubTake = (a: { subTake: string }, b: { subTake: string }) => getTakeStringSortOrder(a.subTake, b.subTake);

export const getTakeStringSortOrder = (a: string, b: string) => a.length > b.length ? 1 : b.length > a.length ? -1 : a.localeCompare(b);

export const sortByCompNo = <T extends { compNo: number }>(a: T, b: T) => a.compNo - b.compNo;

/**
 * Builds a comp's display label, e.g. "Comp 1". If `name` is already a
 * "Comp"-prefixed label (from a previously saved default, including legacy
 * data), it's used as-is to avoid a doubled "Comp Comp 1" prefix.
 */
export const formatCompLabel = (name: string | null | undefined, compNo: number): string => {
    const trimmed = name?.trim();
    if (!trimmed) return `Comp ${compNo}`;
    return /^comp\b/i.test(trimmed) ? trimmed : `Comp ${trimmed}`;
}